import { ReactNode } from 'react';

type ChatItemWrapperProps = {
  children: ReactNode;
  isEditing?: boolean;
  isPinned?: boolean;
  isMobile?: boolean;
  className?: string;
};

export const ChatItemWrapper = ({
  children,
  isEditing = false,
  isPinned = false,
  isMobile = false,
  className = '',
}: ChatItemWrapperProps) => {
  return (
    <div
      className={`group transition duration-300 ${
        isEditing ? 'mt-[30px] border border-r-0 border-[#D9D9D9] bg-[#f9f9f9]' : ''
      } ${isPinned ? 'bg-[#FCFBE8]' : 'hover:bg-gray-10 lg:hover:bg-gray-100'} ${
        isMobile ? 'select-none' : ''
      } ${className}`}
    >
      {children}
    </div>
  );
};
